import { Link } from '@inertiajs/react';
import { AuthHeader } from 'Components';
import { PrimaryButton, SecondaryButton } from 'Shared/Components/Buttons';
import route from 'ziggy-js';

export default function Start() {
  return (
    <>
      <div className="flex flex-col items-center justify-center whitespace-nowrap pb-10">
        <AuthHeader>Welcome to Funeral Stream</AuthHeader>
        <p className="text-center whitespace-pre-line text-sm text-gray-800 leading-normal -mx-20">
          If you represent a funeral home or work as a videographer, please use the “Login or Register” button to access "Funeral Stream". For those
          attending a funeral, kindly proceed by clicking the “Watch a Stream” button.
        </p>
        <strong className="text-xs text-gray-800 leading-normal">No account creation is necessary for viewing purposes.</strong>
      </div>
      <div className="flex justify-between gap-4">
        <PrimaryButton>
          <a href={route('global.public-list')}>Watch a stream</a>
        </PrimaryButton>
        <SecondaryButton>
          <Link href={route('login')}>Login or Register</Link>
        </SecondaryButton>
      </div>
    </>
  );
}
